export const DATA_MASKS = {
  date: 'MM/dd/yyyy',
  phone: '000-000-0000'
};
